import { useMutation } from '@tanstack/react-query';

import PackagesService from '~/services/PackagesService';

import type { SaveOfferPackageParams } from './useSaveOfferPackage';

type UpdatePackageParams = Omit<SaveOfferPackageParams, 'packageInclusions'>;

export function useUpdatePackage() {
  return useMutation({
    mutationFn: ({ offerId, packageData, packageId }: UpdatePackageParams) =>
      PackagesService.updatePackage(packageData, offerId, packageId),
  });
}
